export const BILLING_OVERLAP_STATUS_STREAM_PATH = 'stream';

export const BILLING_OVERLAP_STATUS_SSE_EVENT = 'overlap_status';

export const BILLING_OVERLAP_STATUS_UPDATE_EVENT = 'billing-overlap__update';
